<main>
  <div class="page-content">
    <h5>Ran Default Configuration</h5>
    <section class="frequency-range-section">
      <label class="section-title">Frequency Range</label>
      <div class="dropdown">
        <button
          type="button"
          class="dropdown-toggle form-control"
          id="selectedFrequencyRange"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {{ selectedFrequencyRange }}
        </button>
        <ul
          class="dropdown-menu w-100"
          aria-labelledby="selectedFrequencyRange"
        >
          @for (
            frequencyRange of AVAILABLE_FREQUENCY_RANGES;
            track frequencyRange
          ) {
            <li>
              <button
                type="button"
                class="dropdown-item"
                [class.selected]="selectedFrequencyRange === frequencyRange"
                (click)="fetchConfiguration(frequencyRange)"
              >
                {{ frequencyRange }}
              </button>
            </li>
          }
        </ul>
      </div>
    </section>

    <oaibox-ran-configuration-form
      style="z-index: 4"
      [editableRanConfiguration]="defaultRanConfiguration"
      (ranConfigurationChanges)="updateConfiguration($event)"
    >
    </oaibox-ran-configuration-form>
    <div class="footer" oaiboxStickyFooter>
      <button class="btn btn-ignore" (click)="goBack()">Discard</button>
      <button
        class="btn btn-success"
        (click)="saveDefaultConfiguration()"
        [disabled]="requestOnGoing"
      >
        Save
        @if (requestOnGoing) {
          <i class="fa-solid fa-spinner rotating"></i>
        }
      </button>
    </div>
  </div>
</main>
